import clsx from "clsx";
import { useRef, useState } from "react";

import { ContentDivider } from "@atoms/contentDivider";
import { Typography } from "@atoms/typography";
import { IButtonSizeEnum } from "@molecules/button";
import { ButtonGroup } from "@molecules/buttonGroup";
import { downloadFile } from "@utils";

import classes from "./styles.module.scss";

import type React from "react";

import type { IImageViewerProps } from ".";

const ZOOM_RATE = 0.1;

export function ImageViewer({ src, title, header }: IImageViewerProps) {
  // const { t } = useTranslation("action");

  const containerRef = useRef<HTMLDivElement>(null);
  const ref = useRef<HTMLImageElement>(null);
  const [imgScale, setImgScale] = useState(1);
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

  const handleMouseDown = (
    event: React.MouseEvent<HTMLImageElement, MouseEvent>,
  ) => {
    event.stopPropagation();
    event.preventDefault();

    setIsDragging(true);
    setDragStart({ x: event.clientX, y: event.clientY });
  };

  const handleMouseMove = (
    event: React.MouseEvent<HTMLImageElement, MouseEvent>,
  ) => {
    event.stopPropagation();
    event.preventDefault();

    if (isDragging && containerRef.current) {
      const deltaX = event.clientX - dragStart.x;
      const deltaY = event.clientY - dragStart.y;

      containerRef.current.scrollLeft -= deltaX;
      containerRef.current.scrollTop -= deltaY;

      setDragStart({ x: event.clientX, y: event.clientY });
    }
  };

  const handleMouseUp = (
    event: React.MouseEvent<HTMLImageElement, MouseEvent>,
  ) => {
    event.stopPropagation();
    event.preventDefault();

    setIsDragging(false);
  };

  return (
    <div className={clsx(classes.imgViewer)}>
      {/* <div className={clsx(classes.imgViewer__header)}>
        {header?.title && (
          <>
            <EntityContent
              title={header.title}
              description={header.description}
              priority={IEntityContentPriorityEnum.Regular}
              iconProps={{
                iconName: header.icon,
              }}
            />
            <FastButton type={"closeAlert"} onClick={header.onClose} />
          </>
        )}
      </div>
      */}

      <Typography fontType={"paragraph-medium"} themeColor={"text-strong-900"}>
        {header?.title}
      </Typography>
      {header?.title && <ContentDivider />}

      <Typography>{header?.title}</Typography>

      <div className={clsx(classes.container)}>
        <div
          className={clsx(
            classes.imgContainer,
            isDragging && classes.dragCursor,
          )}
          ref={containerRef}
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
        >
          {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
          <img
            ref={ref}
            style={{
              width: `${imgScale * 100}%`,
            }}
            src={src}
            alt={title}
            className={clsx(classes.imgContainer__image)}
            // onDoubleClick={handleDoubleClick}
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
          />
        </div>
      </div>
      <div className={clsx(classes.imgViewer__button)}>
        <ButtonGroup
          size={IButtonSizeEnum.Small}
          buttons={[
            {
              key: "1",
              startIcon: "ZoomInLine",
              onClick: () => {
                setImgScale((prevState) => prevState + ZOOM_RATE);
              },
              disabled: imgScale > 50,
            },
            {
              key: "2",
              startIcon: "ZoomOutLine",
              onClick: () => {
                setImgScale((prevState) => prevState - ZOOM_RATE);
              },
              disabled: imgScale <= 1,
            },
            {
              key: "3",
              startIcon: "Download2Line",
              onClick: () => {
                downloadFile(src);
              },
            },
          ]}
        />
      </div>
    </div>
  );
}
